"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroIntroduction() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="227835" id="hero" className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/pre_listing_inspection_home.png)]" />

      {}
      <div className="absolute inset-0 bg-secondary/80 mix-blend-multiply" />

      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/subtle_grain_overlay.png)] opacity-20 mix-blend-overlay pointer-events-none" />

      {}
      <div className="absolute bottom-0 left-0 right-0 h-3/4 bg-gradient-to-t from-primary/20 via-primary/5 to-transparent pointer-events-none" />

      {}
      <div ref={contentRef} className={`relative z-10 container mx-auto px-4 md:px-6 text-center flex flex-col items-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="font-default text-5xl md:text-7xl lg:text-[60px] font-bold text-primary-foreground leading-tight tracking-tighter max-w-5xl drop-shadow-sm">
          Sell With Confidence Using a{" "}
          <span className="text-primary drop-shadow-md">Pre-Listing Inspection</span>
        </h1>

        <p className="font-sans text-lg md:text-xl text-primary-foreground/90 max-w-2xl mt-6 leading-relaxed">
          Identify potential issues before they hit the market. Our comprehensive 
          evaluations help South Florida sellers maximize value and close faster.
        </p>

        <Button asChild size="lg" className="mt-10 rounded-md text-lg px-10 py-7 bg-primary hover:bg-primary/90 text-primary-foreground shadow-xl shadow-primary/20 hover:shadow-2xl hover:shadow-primary/40 transition-all duration-300 hover:-translate-y-1">
          <Link to="/PreListingInspectionPage">
            Schedule Your Inspection
            <ArrowRight className="ml-2 size-5" />
          </Link>
        </Button>
      </div>
    </section>;
}